import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as MDICONS from '@material-ui/icons';
import ReactModal from 'react-modal';
import JoinProjectModal from './JoinProjectModal';
import { dateConverter } from '../../../../helper/Helper';

class JoinProjectCard extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showConfirmModal: false,
        }
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = (num) => {
        switch (num) {
            case 0: {
                this.setState({ showConfirmModal: true });
                break;
            }
            default: {
                this.setState({ showConfirmModal: false });
            }
        }
    }

    handleCloseModal = (num) => {
        switch (num) {
            case 0: {
                this.setState({ showConfirmModal: false });
                break;
            }
            default: {
                this.setState({ showConfirmModal: false });
            }
        }
    }

    render() {
        const textStyle = { textAlign: "start", padding: "10px" };

        const { joinProject, userData, modalStyles } = this.props;
        const { projectTitle, companyName, dateCreated } = joinProject;

        var parsedDate = dateConverter(dateCreated).parsedDate;

        const ueid = userData.uid + userData.employeeid;
        const isUserAlreadyIn = ueid in joinProject.accessMap;

        const relevantButton = isUserAlreadyIn ?
            (<p></p>)
            :
            (<button className="btn btn-dark btn-sm m-5" onClick={() => { this.handleOpenModal(0) }}>Send project request</button>)

        return (
            <React.Fragment>
                <div className="row">
                    {/* PROJECT CARD */}
                    <div className="col-12 col-md-5">
                        <div className="card p-3 mb-5">
                            <div className="card-header bg-white p-0">
                                <div className="row">
                                    <div className="col-8">
                                        <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>Project detail</p>
                                    </div>
                                    <div className="col-4">
                                    </div>
                                </div>
                            </div>
                            <ul className="card-body list-group align-items-start list-group-flush border-0">
                                <li className="list-group-item py-2 border-0" ng-repeat="i in filters"><MDICONS.DashboardRounded /><span className="ml-3">{projectTitle}</span></li>
                                <li className="list-group-item py-2 border-0" ng-repeat="i in filters"><MDICONS.ApartmentRounded /><span className="ml-3">{companyName}</span></li>
                                <li className="list-group-item py-2 border-0" ng-repeat="i in filters"><MDICONS.DateRangeRounded /><span className="ml-3">Created on: {parsedDate}</span></li>
                            </ul>
                            <br />
                            <br />
                            {relevantButton}
                            <br />
                        </div>
                    </div>

                    {/* INSTRUCTIONS */}
                    <div className="col-12 col-md-7">
                        <div className="card p-3">
                            <div className="card-header bg-white p-0">
                                <div className="row">
                                    <div className="col-8">
                                        <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>Terms and conditions</p>
                                    </div>
                                    <div className="col-4">
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <ol>
                                    <li style={textStyle}>You must comply with your company's terms and our terms.</li>
                                    <li style={textStyle}>You must note that you can be removed by either your company or by AssetTag on any misconduct.</li>
                                    <li style={textStyle}>If you are found distributing QR code without permission and compliance.</li>
                                </ol>

                            </div>
                        </div>
                    </div>
                </div>

                {/* CONFIRM MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showConfirmModal}
                    onRequestClose={() => { this.handleCloseModal(0) }}
                    contentLabel="Confirm send project request"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal(0) }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <JoinProjectModal />
                </ReactModal>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidthMedium: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,

        userData: state.firebase.profile,
    }
}

export default connect(mapStateToProps)(JoinProjectCard)
